module.exports = __webpack_public_path__ + "img/xtts2.70734008.png";